module.exports = __webpack_public_path__ + "img/objekat1.090d14a0.png";